import { useState, useEffect } from "react";
import { Button, Badge } from "react-bootstrap";
import RfqResponseForm from "./RfqResponseForm";

const RfqResponsesTable = ({ rfqId, fetchResponses }) => {
    // The parent passes the whole rfq object as `rfqId` (historic name). Normalize it to `rfqData`.
    const initialRfq = rfqId || { rfq: {}, recipients: [], responses: [], items: [] };
    const [rfqData, setRfqData] = useState(initialRfq);

    // Update rfqData when rfqId prop changes
    useEffect(() => {
        setRfqData(rfqId || { rfq: {}, recipients: [], responses: [], items: [] });
    }, [rfqId]);
    const [editData, setEditData] = useState(null);

    // const fetchResponses = async () => {
    //     const res = await axios.get(`${config.API_BASE_URL}/rfqs/${rfqId}`);
    //     setRfqData(res.data);
    // };

    // useEffect(() => {
    //     fetchResponses();
    // }, [rfqId]);

    const openForm = (rec) => {
        const prefilledItems =
            rec.response?.items && rec.response.items.length > 0
                ? rec.response.items
                : rfqData.items.map(item => ({
                    product: item.product?._id || item.product,
                    product_name: item.product?.productName || "",
                    quality: item.quality || "",
                    quantity: item.required_quantity,
                    quantity_unit: item.quantity_unit,
                    rate: 0,
                    unit_rate: 0,
                    total_price: 0,
                }));

        setEditData({
            ...rec,
            response: {
                ...rec.response,
                items: prefilledItems,
            },
        });
    };

    // Defensive: ensure arrays exist
    const recipients = Array.isArray(rfqData.recipients) ? rfqData.recipients : [];
    const responses = Array.isArray(rfqData.responses) ? rfqData.responses : [];

    const merged = recipients.map((rec) => {
        const matchedResponse = responses.find((r) => {
            // `r.rfq_recipient` may be an id string or an embedded object with `_id`.
            if (!r.rfq_recipient) return false;
            if (typeof r.rfq_recipient === 'string') return r.rfq_recipient === rec._id;
            if (typeof r.rfq_recipient === 'object') return r.rfq_recipient._id === rec._id;
            return false;
        });
        return { ...rec, response: matchedResponse || null };
    });


    const vendors = merged.filter((r) => r.recipient_type === "vendor");
    const brokers = merged.filter((r) => r.recipient_type === "broker");

    const renderAccordion = (list, type) => {
        return (
            <>
                <h5 className="mt-4 mb-3">{type === "vendor" ? "Vendor" : "Broker"} Quotations</h5>
                <div className="card card-body">


                    <div className="accordion" id="accordionExample">
                        {list.map((rec, idx) => {
                            // `merged` attaches a single `response` to each recipient (or null).
                            // Previously this code checked `rec.responses` (plural) which doesn't exist
                            // so responses never appeared in the UI. Check `rec.response` instead.
                            const hasResponse = !!rec.response;
                            const response = rec.response || {};
                            const responseItems = response.items || [];

                            return (
                                <div className="accordion-item border-top mb-4" key={rec._id}>
                                    <h2 className="accordion-header" id={`heading${idx}`}>
                                        <button
                                            className={`accordion-button ${idx === 0 ? "" : "collapsed"}`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#collapse${idx}`}
                                            aria-expanded={idx === 0 ? "true" : "false"}
                                            aria-controls={`collapse${idx}`}
                                        >
                                            <span>{rec.recipient_details.business_name || "Unnamed"}</span>
                                            <Badge
                                                bg={hasResponse
                                                    ? (response.status === "approved" ? "success" : "warning")
                                                    : "secondary"}
                                                className="ms-2"
                                            >
                                                {hasResponse ? response.status : "No Quotation Yet"}
                                            </Badge>
                                        </button>
                                    </h2>
                                    <div
                                        id={`collapse${idx}`}
                                        className={`accordion-collapse collapse ${idx === 0 ? "show" : ""}`}
                                        aria-labelledby={`heading${idx}`}
                                        data-bs-parent="#accordionExample"
                                    >
                                        <div className="accordion-body p-2 p-md-3 rounded shadow-sm">
                                            {hasResponse ? (
                                                <>
                                                <p><strong>Quotation Number:</strong> {response.quotationId || "N/A"}</p>
                                                    <p><strong>Expected Delivery:</strong> {response.expected_delivery_date ? new Date(response.expected_delivery_date).toLocaleDateString('en-GB', {
                                                        day: '2-digit',
                                                        month: 'short',
                                                        year: 'numeric'
                                                    }).replace(/ /g, ' ') : "—"}</p>
                                                    <p><strong>Notes:</strong> {response.response_notes || "—"}</p>
                                                    <p><strong>Tax:</strong> {response.tax || 0} %</p>
                                                    <p><strong>Items:</strong></p>
                                                    <table className="table table-striped table-bordered table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th>Product Name</th>
                                                                <th>Quality</th>
                                                                <th>Quantity</th>
                                                                <th>Unit Price</th>
                                                                <th>Total Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {responseItems.map((item, i) => (
                                                                <tr key={i}>
                                                                    <td>{item.product_name || item.product?.productName || item.product}</td>
                                                                    <td>{item.quality}</td>
                                                                    <td>{item.quantity} {item.quantity_unit}</td>
                                                                    <td>₹{item.unit_rate}</td>
                                                                    <td>₹{item.total_price}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                    <Button
                                                        size="sm"
                                                        variant="outline-primary"
                                                        onClick={() => openForm({
                                                            ...rec,
                                                            items: responseItems,
                                                        })}
                                                    >
                                                        Edit Quotation
                                                    </Button>
                                                </>
                                            ) : (
                                                <>
                                                    <p className="text-muted mb-2">No quotation submitted yet.</p>
                                                    <Button
                                                        size="sm"
                                                        variant="outline-success"
                                                        onClick={() => openForm({
                                                            ...rec,
                                                            items: rfqData.items // or prefill here if needed
                                                        })}
                                                    >
                                                        Add Quotation
                                                    </Button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            {renderAccordion(vendors, "vendor")}
            {renderAccordion(brokers, "broker")}

            {editData && (
                <RfqResponseForm
                    show={!!editData}
                    data={editData}
                    onHide={() => setEditData(null)}
                    onSaved={fetchResponses}
                    defaultDD={rfqData.rfq.delivery_date}
                />
            )}
        </>
    );
};

export default RfqResponsesTable;
